import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";

const KEY = "hg_cookie_consent";

export default function CookieConsent() {
  const { t } = useApp();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setShow(true);
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, JSON.stringify({ accepted: true, at: new Date().toISOString() }));
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="cookie-consent"
      className="fixed bottom-0 inset-x-0 z-[60] bg-ink text-paper px-5 md:px-10 py-5"
    >
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-8">
        <p className="text-xs md:text-sm font-light leading-relaxed text-paper/80 flex-1">
          {t.cookie.text}{" "}          <Link to="/legal/cookies" className="underline hover:text-accent" data-testid="cookie-policy-link">
            {t.cookie.policy}
          </Link>
          .
        </p>
        <button
          onClick={accept}
          data-testid="cookie-accept-btn"
          className="shrink-0 bg-paper text-ink px-6 py-2.5 text-xs uppercase tracking-[0.2em] transition-colors duration-500 hover:bg-accent"
        >
          {t.cookie.accept}
        </button>
      </div>
    </div>
  );
}
